import { Injectable } from '@angular/core';
import { Observable ,  from as fromPromise ,  throwError as _throw ,  defer } from 'rxjs';
import { StorageItem } from './storage-item';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CachingService {
	private timeToLive: number = 60 * 60;
	private readonly keyPrefix: string = 'fs_';
	private invalidateOffline: boolean = false;
	private cacheEneabled: boolean = false;

	constructor() {}

	public get ttl(): number {
		return this.timeToLive;
	}

	/**
	 * Load request from cache, if request is cached.
	 * @param {string} key unique key for storing
	 * @param {Observable} observable http observable
	 * @param {number} ttl Time to live for cached item
	 * @return                     [description]
	 */
	public loadFromCache<T = any>(key: string, observable: Observable<T>, ttl?: number): Observable<T> {
		if (!this.cacheEneabled) {
			return observable;
		}

		// return defer(() => {
		// 	return fromPromise(this.getItem(key)).pipe(
		// 		catchError(err => {
		// 			observable.subscribe(
		// 				response => {
		// 					return this.saveToCache(key, response, ttl);
		// 				},
		// 				error => {
		// 					return _throw(error);
		// 				},
		// 			);

		// 			return observable;
		// 		}),
		// 	);
		// });
	}

	/**
	 * Saves value to cache
	 * @param {string} key unique key for storing
	 * @param {any} value value for storing
	 * @param {number} ttl time to live for cached item
	 * @return
	 */
	// private saveToCache(key: string, value: any, ttl?: number): Promise<any> {
    private saveToCache(key: string, value: any, ttl?: number) {
		if (ttl == null) {
			ttl = Date.now() + this.timeToLive * 1000;
		}
		let type = typeof value;
		let item = new StorageItem(key, value, ttl, type);
		// return this.save(key, item);
	}

	/**
	 * Save StorageItem to storage
	 * @param {string} key unique key for storing
	 * @param {StorageItem} element element to store
	 * @return
	 */
	private save(key: string, element: StorageItem) {
		//return this.storage.set(this.prefixKey(key), element);
	}

	/**
	 * Load element from storage
	 * @param {string} key unique key
	 * @return
	 */
	//private load<T = any>(key: string): Promise<T> {
    private load<T = any>(key: string) {
		//return this.storage.get(this.prefixKey(key));
	}

	/**
	 * [getItem description]
	 * @param {string} key [description]
	 * @return     [description]
	 */
	private async getItem(key: string) {
		// let data = await this.load(key);

		// if (!!data) {
		// 	// let parsedData = JSON.parse(data) as StorageItem;
		// 	// let item = new StorageItem(parsedData.key, parsedData.value, parsedData.expires, parsedData.object);

		// 	// if (!item.isExpired()) {
		// 	// 	return item.value;
		// 	// }
		// }

		// throw new Error('Request is not cached');
	}

	/**
	 * Clear all items in cache
	 */
	public clearCache(): void {
		//this.storage.clearStorage(this.keyPrefix);
	}

	/**
	 * Builds a key with prefix
	 * @param {string} key [description]
	 * @return     [description]
	 */
	private prefixKey(key: string): string {
		if (key.startsWith(this.keyPrefix)) {
			return key;
		}

		return this.keyPrefix + key;
	}

	/**
	 * Removes prefix from key
	 * @param {string} key [description]
	 * @return     [description]
	 */
	private removePrefix(key: string): string {
		if (key.startsWith(this.keyPrefix)) {
			return key.substr(this.keyPrefix.length);
		}

		return key;
	}
}
